(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pp-halloween-coupon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-halloween-coupon')) {
    customElements.define('pp-halloween-coupon', class extends HTMLElement {
      connectedCallback() {
        if (this.onCopy) return;
        this.button = this.querySelector('button');
        this.label = this.querySelector('[data-copy-label]');
        this.status = this.querySelector('[role="status"]');
        this.onCopy = async () => {
          if (this.copying) return;
          this.copying = true;
          const code = this.dataset.code;
          let copied = false;
          try {
            if (navigator.clipboard && window.isSecureContext) {
              await navigator.clipboard.writeText(code);
              copied = true;
            }
          } catch (_) {}
          if (!copied) {
            const field = document.createElement('textarea');
            field.value = code;
            field.setAttribute('readonly', '');
            field.style.cssText = 'position:fixed;left:0;top:0;width:1px;height:1px;opacity:0;font-size:16px;pointer-events:none';
            document.body.appendChild(field);
            field.focus({ preventScroll: true });
            field.select();
            field.setSelectionRange(0, code.length);
            try { copied = document.execCommand('copy'); } catch (_) {}
            field.remove();
            this.button.focus({ preventScroll: true });
          }
          clearTimeout(this.resetTimer);
          this.status.toggleAttribute('data-copy-error', !copied);
          this.status.textContent = copied ? this.dataset.success : this.dataset.failure;
          this.button.toggleAttribute('data-copied', copied);
          this.label.textContent = copied ? this.dataset.copiedLabel : this.dataset.copyLabel;
          if (copied) {
            this.resetTimer = setTimeout(() => {
              this.label.textContent = this.dataset.copyLabel;
              this.button.removeAttribute('data-copied');
              this.status.textContent = '';
            }, 2500);
          }
          this.copying = false;
        };
        this.button.addEventListener('click', this.onCopy);
      }
      disconnectedCallback() {
        clearTimeout(this.resetTimer);
        this.button?.removeEventListener('click', this.onCopy);
        this.onCopy = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
